module.exports = "<div class=\"banner-container\" *ngIf=\"visibleBanner\"\n     [innerHTML]=\"visibleBanner.template\" data-testid=\"banner\">\n</div>\n";